import { render, staticRenderFns } from "./MediaMTXWebRTCReader.vue?vue&type=template&id=8c03cd86"
import script from "./MediaMTXWebRTCReader.vue?vue&type=script&lang=js"
export * from "./MediaMTXWebRTCReader.vue?vue&type=script&lang=js"
import style0 from "./MediaMTXWebRTCReader.vue?vue&type=style&index=0&id=8c03cd86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports